import { useParams } from 'react-router-dom';
import {
  OPEN_SURVEY_ROUTE,
  OPEN_SURVEY_SUBMIT_ROUTE,
  OPEN_SURVEY_THANKYOU_ROUTE,
  SURVEY_ROUTE,
  SURVEY_SUBMIT_ROUTE,
  SURVEY_THANKYOU_ROUTE,
} from '../constants/routes';
import { useAppSelector } from '../redux/ReduxProvider';

const STANDARD_ROUTES = { survey: SURVEY_ROUTE, submit: SURVEY_SUBMIT_ROUTE, thankYou: SURVEY_THANKYOU_ROUTE };
const OPEN_ROUTES = {
  survey: OPEN_SURVEY_ROUTE,
  submit: OPEN_SURVEY_SUBMIT_ROUTE,
  thankYou: OPEN_SURVEY_THANKYOU_ROUTE,
};

// A Shared Link survey renders the standard pages under /s/:open_survey_id instead of /survey/:survey_code.
export const useSurveyRoutes = () => {
  const { survey_code: surveyCode, open_survey_id: openSurveyId } = useParams();
  const isOpenSurvey = useAppSelector((state) => !!state.survey.openSurvey);

  return {
    routes: isOpenSurvey ? OPEN_ROUTES : STANDARD_ROUTES,
    surveyCode: surveyCode ?? openSurveyId ?? null,
  };
};
